import { render } from "./CorpoPastoral.vue?vue&type=template&id=e4ea49f4&scoped=true&lang=pug"
import script from "./CorpoPastoral.vue?vue&type=script&setup=true&lang=js"
export * from "./CorpoPastoral.vue?vue&type=script&setup=true&lang=js"

import "./CorpoPastoral.vue?vue&type=style&index=0&id=e4ea49f4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4ea49f4"]])

export default __exports__